import { asDecimal, asQuantity } from '../utils/formatters';

export default [
  {
    displayString: '30 Year Max DBH',
    accessor: 'maxDbh',
    format: (maxDbh, { dbhUnit }) => asQuantity(maxDbh, { unit: dbhUnit }),
  },
  {
    displayString: '20 Year Tons CO2/tree',
    accessor: 'twentyYearTonsPerTree',
    format: asDecimal,
  },
  {
    displayString: '30 Year Tons CO2/tree',
    accessor: 'thirtyYearTonsPerTree',
    format: asDecimal,
  },
  {
    displayString: 'Avg. tons CO2 per year/tree',
    accessor: 'avgTonsPerYearPerTree',
    format: asDecimal,
  },
];
